import { Dispatch } from 'redux';
import { Language } from './users.reducer';

export enum UserTypes {
  ChangeLanguage = 'users/ChangeLanguage'
}

export type UserAction = { type: UserTypes.ChangeLanguage; language: Language };

export const actionCreators = {
  changeLanguage: (language: Language): UserAction => ({
    type: UserTypes.ChangeLanguage,
    language
  })
};

export const setUserLanguage = (language: Language) => {
  return async (dispatch: Dispatch) => {
    return dispatch(actionCreators.changeLanguage(language));
  };
};
